import { UPDATE_BASKET, UPDATE_BASKET_ERROR, UPDATE_BASKET_SUCCESS } from "core-web/state/models/Basket/constants";

import { BasketEvents } from "core-web/libs/Events/constants";
import Events from "core-web/libs/Events";
import UpdateBasket from "core-web/libs/GrebbCommerceAPI/Basket/UpdateBasket";
import { acquireMutex } from "core-web/state";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import store from "core-web/state/store";

export const updateBasket = (data, skipEvent) => async (dispatch, getState) => {
    const mutexLock = await acquireMutex("basket.getBasket");
    const basketId = getState().basket.basketId;
    dispatch({ type: UPDATE_BASKET });
    try {
        const response = await UpdateBasket(basketId, data);
        const responseBody = await response.body();

        const basketItemsTree = buildCartProductTree(responseBody.data.items);

        dispatch({
            type: UPDATE_BASKET_SUCCESS,
            items: basketItemsTree,
            info: responseBody.data.info,
            comment: responseBody.data.comment,
            summary: responseBody.data.format.summary,
        });

        if (!skipEvent) {
            Events.trigger(BasketEvents.UPDATED);
        }
        mutexLock();

        return true;
    } catch (e) {
        dispatch({ type: UPDATE_BASKET_ERROR });
        mutexLock();

        return { error: true };
    }
};

export default (data, skipEvent) => store.dispatch(updateBasket(data, skipEvent));
